// Import necessary Firebase modules
import { getFunctions, httpsCallable } from "firebase/functions";
import { v4 as uuidv4 } from "uuid"; // UUID library for generating unique IDs

// Initialize Firebase Functions
const functions = getFunctions();

// Function to log AI token usage data to Firestore
export async function logTokenUsage({
  usage,
  userID,
  systemName,
  action,
  company,
  collectionBrand,
}) {
  try {
    // Prepare document data with the required fields
    const documentData = {
      date: new Date().toISOString().split("T")[0], // Current date in YYYY-MM-DD format
      time: new Date().toISOString().split("T")[1], // Current time in HH:MM:SS format
      userID,
      systemName, // Actual system where the action took place
      action,
      prompt_tokens: usage.prompt_tokens,
      completion_tokens: usage.completion_tokens,
      total_tokens: usage.total_tokens,
    };
    const uniqueEntryId = uuidv4();

    // Call the Firestore operations function to write the data
    const firestoreOperations = httpsCallable(functions, "firestoreOperations");
    await firestoreOperations({
      operation: "write",
      company: company,
      collectionBrand: collectionBrand,
      systemName: "tokenManagement",
      uniqueId: uniqueEntryId,
      documentData: documentData,
    });
  } catch (error) {
    console.error("Error logging token usage to Firestore:", error);
    throw new Error("Failed to log token usage data to Firestore.");
  }
}
